import type { ISourceOptions } from '@tsparticles/engine'

export const heroParticlesConfig: ISourceOptions = {
  background: {
    color: {
      value: 'transparent',
    },
  },
  fpsLimit: 120,
  interactivity: {
    events: {
      onClick: {
        enable: true,
        mode: 'push',
      },
      onHover: {
        enable: true,
        mode: 'repulse',
      },
    },
    modes: {
      push: {
        quantity: 4,
      },
      repulse: {
        distance: 200,
        duration: 0.4,
      },
    },
  },
  particles: {
    color: {
      value: ['#14b8a6', '#2dd4bf', '#00D4FF', '#8B5CF6'],
    },
    links: {
      color: '#14b8a6',
      distance: 150,
      enable: true,
      opacity: 0.3,
      width: 1,
    },
    move: {
      direction: 'none',
      enable: true,
      outModes: {
        default: 'bounce',
      },
      random: false,
      speed: 0.5,
      straight: false,
    },
    number: {
      density: {
        enable: true,
      },
      value: 80,
    },
    opacity: {
      value: 0.5,
      animation: {
        enable: true,
        speed: 1,
        sync: false,
      },
    },
    shape: {
      type: 'circle',
    },
    size: {
      value: { min: 1, max: 3 },
      animation: {
        enable: true,
        speed: 2,
        sync: false,
      },
    },
  },
  detectRetina: true,
}

export const ctaParticlesConfig: ISourceOptions = {
  background: {
    color: {
      value: 'transparent',
    },
  },
  fpsLimit: 120,
  particles: {
    color: {
      value: ['#14b8a6', '#2dd4bf', '#00D4FF'],
    },
    move: {
      direction: 'none',
      enable: true,
      outModes: {
        default: 'destroy',
      },
      speed: 3,
    },
    number: {
      value: 0,
    },
    opacity: {
      value: { min: 0.3, max: 1 },
      animation: {
        enable: true,
        speed: 2,
        sync: false,
        destroy: 'min',
      },
    },
    shape: {
      type: ['circle', 'triangle', 'star'],
    },
    size: {
      value: { min: 2, max: 6 },
      animation: {
        enable: true,
        speed: 3,
        sync: false,
        destroy: 'min',
      },
    },
    life: {
      duration: {
        sync: false,
        value: 2,
      },
      count: 1,
    },
  },
  emitters: {
    life: {
      count: 20,
      delay: 0,
      duration: 0.1,
    },
    rate: {
      delay: 0.01,
      quantity: 5,
    },
    size: {
      width: 0,
      height: 0,
    },
  },
  detectRetina: true,
}
